import { SharingScheduleFormValues } from "../components";
import { SharingScheduleRuleTimeFrames, SharingScheduleRules } from "./enums";
export * from "./enums";

export const EMPTY_SHARING_SCHEDULE_FORM_VALUES: SharingScheduleFormValues = {
  name: "",
  dateRange: null,
  numberOfProducts: 4,
  rule: SharingScheduleRules.BestSellingProducts,
  ruleTimeframe: SharingScheduleRuleTimeFrames.ForAllTime,
  ruleTimeNumber: 1,
  productVariants: []
};

export const SharingScheduleRulesLabelsMap = {
  [SharingScheduleRules.BestSellingProducts]: "The (n) best selling products",
  [SharingScheduleRules.ProductsLessThanTenInStock]:
    "The (n) products less than 10 in stock",
  [SharingScheduleRules.MostSharedProducts]: "The (n) most shared products",
  [SharingScheduleRules.HighlyRatedProducts]: "The (n) highly rated products",
  [SharingScheduleRules.MostWishedProducts]: "The (n) most liked products",
  [SharingScheduleRules.MostSearchedProducts]: "The (n) most searched products",
  [SharingScheduleRules.ProductsThatExperiencedSuddenIncreaseInSales]:
    "The (n) products that experienced sudden increase in sales",
  [SharingScheduleRules.PopularProductsThatWereRestocked]:
    "The (n) popular products that were restocked",
  [SharingScheduleRules.HighCartAbandonmentRate]:
    "The (n) high cart abandonment rate",
  [SharingScheduleRules.ManualSelectionOfProducts]:
    "The (n) manually selected products"
};

export const SharingScheduleRuleTimeframeLabelMap = {
  [SharingScheduleRuleTimeFrames.ForAllTime]: "For all time",
  [SharingScheduleRuleTimeFrames.OverPastMonth]: "Over (n) past month",
  [SharingScheduleRuleTimeFrames.OverPastWeek]: "Over (n) past week",
  [SharingScheduleRuleTimeFrames.OverPastDay]: "Over (n) past day",
  [SharingScheduleRuleTimeFrames.OverPastYear]: "Over (n) past year"
};
